import { useEffect, useMemo, useState } from 'react';
import { Accordion, AccordionItem, AccordionItemBody, AccordionItemHeader, CheckboxField, SearchField } from '@wk/components-react16';

const TaxonomyTags = ({ data }: any) => {
    const { prompt, setPrompt, taxonomyTree, setTaxonomyTree } = data;
    const [searchMap, setSearchMap] = useState<Record<string, string>>({});
    const [activePanel, setActivePanel] = useState<string>('' as string);

    const handleUserRequest = (value: any) => {
        if (activePanel === value) {
            setActivePanel('');
            return;
        }
        setActivePanel(value);
    };
    const handleSearchChange = (name: string, value: string) => {
        setSearchMap((prev: any) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSelection = (node: any, checked: boolean = false) => {
        node.isChecked = checked;
        if (checked) {
            const exists = prompt?.tags?.some((tag: any) => tag.id === node.id);
            if (!exists) {
                prompt?.tags?.push(node);
            }
            setPrompt({ ...prompt });

        } else {
            const st = prompt?.tags?.filter((item: any) => item.id != node.id);
            setPrompt({ ...prompt, tags: st });
        }

        const updatedTaxonomyTree = (nodes: any[]): any[] => {
            return nodes.map((item: any) => {
                if (item.id === node.id) {
                    // Update the current node
                    return {
                        ...item,
                        isChecked: checked,
                        children: item.children ? updatedTaxonomyTree(item.children) : [],
                    };
                }

                // Recursively update children if they exist
                if (item.children && item.children.length > 0) {
                    return {
                        ...item,
                        children: updatedTaxonomyTree(item.children),
                    };
                }

                return item;
            });
        };

        const updatedTree = updatedTaxonomyTree(taxonomyTree);
        setTaxonomyTree([...updatedTree]);

    };

    const filterTree = (nodes: any[], term: string): any[] =>
        nodes.map(node => {
            const isMatch = node?.name?.toLowerCase().includes(term.toLowerCase());
            if (isMatch) {
                return { ...node };
            }
            const children = node.children ? filterTree(node.children, term) : [];
            if (children.length > 0) {
                return { ...node, children: children };
            }
            return null;
        }).filter(Boolean);

    const filteredTree = useMemo(() => {
        return taxonomyTree.map((item: any) => {
            const searchTerm = searchMap[item.name] || '';
            if (!searchTerm.trim()) return item;

            return {
                ...item,
                children: filterTree(item.children || [], searchTerm),
            };
        });
    }, [searchMap, taxonomyTree]);

    return (
        <div className="customMultiSelect absolute">
            {filteredTree?.length > 0 ? filteredTree.map((item: any, index: number) => (
                <div key={index} className='multiTree'>
                    <ul className='pl-0 mb-0'>
                        <li className='pt-0 custom-accordion-scroll-hide'>
                            <Accordion>
                                <AccordionItem
                                    controlMode={'controlled'}
                                    isOpen={activePanel === item.name}
                                    onUserRequest={() => handleUserRequest(item.name)} isScrollbarEnabled={false}>
                                    <h2 id="generalSettings" slot="accordionItemHeader">
                                        <AccordionItemHeader>{item?.name}</AccordionItemHeader>
                                    </h2>
                                    <AccordionItemBody slot="accordionItemBody">
                                        <SearchField size="small" label="" labelFor={`search-${index}`}>
                                            <input
                                                type="search"
                                                id={`search-${index}`}
                                                name={item?.name}
                                                value={searchMap[item?.name] || ''}
                                                placeholder={`Search ${item?.name}`}
                                                onChange={(event: any) => handleSearchChange(item.name, event.target.value)}
                                            />
                                        </SearchField>
                                        {item?.children?.length > 0 ?
                                            <RenderTreeChild items={item.children} handleSelection={handleSelection} />
                                        : <span className="text-center">No Data Found</span>}
                                        </AccordionItemBody>
                                </AccordionItem>
                            </Accordion>
                        </li>
                    </ul>
                </div>
            )) : (<div className="p-20 text-center">No Taxonomy Found.</div>)}
        </div>
    );
};

export const RenderTreeChild = ({ items, handleSelection }: any) => {
    return (items && <ul className='mb-0'> {items.map((item: any, i: number) => {
        if (item.children && item.children.length > 0) {
            return (
                <li key={i}>
                    <span className='item pe-none'>{item.name}</span>
                    <RenderTreeChild items={item.children} handleSelection={handleSelection} />
                </li>
            );
        } else {
            return (
                <li key={i}>
                    <span className='item'>
                        <CheckboxField label={item.name}>
                            <input
                                name="tag"
                                type="checkbox"
                                checked={item.isChecked || false}
                                onChange={(event: any) => handleSelection(item, event.target.checked)}
                            />
                        </CheckboxField>
                    </span>
                </li>
            );
        }
    })}
    </ul>
    )
};

export default TaxonomyTags;